import { StandaloneSearchBoxProps } from '@react-google-maps/api'
import { useCallback, useRef } from 'react'
import { GeolocPosition } from './useGeolocPosition'

export const useStandaloneSearchBox = ({
	onChangePosition,
}: {
	onChangePosition: (position: GeolocPosition) => void
}): StandaloneSearchBoxProps => {
	const searchBoxRef = useRef<google.maps.places.SearchBox>()

	const onLoad = useCallback((box: google.maps.places.SearchBox) => {
		searchBoxRef.current = box
	}, [])

	const onPlacesChanged = useCallback(() => {
		const searchBox = searchBoxRef.current
		if (!searchBox) {
			return
		}
		const places = searchBox.getPlaces()
		if (!places || !places[0]?.geometry?.location) {
			return
		}
		const location = places[0].geometry.location.toJSON()
		onChangePosition({
			location,
			address: places[0].formatted_address! || places[0].name!,
		})
	}, [onChangePosition])

	return { onLoad, onPlacesChanged }
}
